module.exports = __webpack_public_path__ + "media/customizations/bigsky/logo-14a9cbb6b05a09554e1112500f954e49.png";